import { render, staticRenderFns } from "./AlvoradaReservaUti.vue?vue&type=template&id=06bfad3e&scoped=true"
import script from "./AlvoradaReservaUti.vue?vue&type=script&lang=ts"
export * from "./AlvoradaReservaUti.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bfad3e",
  null
  
)

export default component.exports